import {
  REQUEST_SEARCH_CLAIM_INFO,
  SET_SEARCH_CLAIM_INFO,
  REQUEST_MAKE_DECISION_CLAIM,
  RESET_STORE_OPEN_CLAIM,
} from 'containers/OpeningClaimPageManager/constants';

export const requestSearchClaimInfo = (
  payload: string,
  failedCallBack: Function,
) => ({
  type: REQUEST_SEARCH_CLAIM_INFO,
  payload,
  failedCallBack,
});
export const setSearchClaimInfo = (payload: string) => ({
  type: SET_SEARCH_CLAIM_INFO,
  payload,
});
export const requestMakeDecisionClaim = (
  payload: string,
  successCallBack: Function,
) => ({
  type: REQUEST_MAKE_DECISION_CLAIM,
  payload,
  successCallBack,
});
export const resetStore = () => ({
  type: RESET_STORE_OPEN_CLAIM,
});
